const productcolor = {
    add: 'productcolor/add',
    update: 'productcolor/update',
    remove: 'productcolor/remove',
    get: 'productcolor/get',
    getall: 'productcolor/getall',
    setdefault: 'productcolor/set-default',
}
export default productcolor
